/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import { Grid, Box } from '@mui/material';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import ModalFooter from '../../CustomModal/ModalFooter';
import _ from 'lodash';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import Compdirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allEmpDocTypes: [];
  allCountires: [];
  callBackData: (data: any) => void;
  IndividualDocuments: any;
  trans?: any;
}
const EditDocsModalPresenter = ({
  isModalOpen,
  closeModal,
  allEmpDocTypes,
  allCountires,
  IndividualDocuments,
  callBackData,
  trans,
}: ModalProps) => {
  const [document_type, setdocument_type] = useState(
    IndividualDocuments?.documen_type?.type,
  );
  const [EmpDocTypeId, setEmpDocTypeId] = useState(
    IndividualDocuments?.documen_type?.id,
  );
  const [countryName, setCountryName] = useState(
    IndividualDocuments?.issue_country,
  );
  const [, setCountryId] = useState();
  const [issueDate, setissueDate] = useState<any>(
    IndividualDocuments?.issue_date,
  );
  const [expiredDate, setExpiredDate] = useState<any>(
    IndividualDocuments.validity_date,
  );
  const [identifierNo, setIdentifierNo] = useState(
    IndividualDocuments?.identifier_number,
  );
  const [proofAttachment, setProofAttachment] = useState('');
  const [proofAttachmentPath, setProofAttachmentPath] = useState(
    IndividualDocuments?.document,
  );
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [removeImage, setRemoveImage] = useState('false');
  const [remarks, setRemarks] = useState(IndividualDocuments?.remarks);
  const [newattachement, setNewAttachement] = useState(false);

  const [showReferenceNo, setShowReferenceNo] = useState(false);
  const [showAddReferenceNo, setShowAddReferenceNo] = useState(false);
  const [referenceNo, setReferenceNo] = useState(
    IndividualDocuments?.reference_number,
  );
  const [addReferenceNo, setAddReferenceNo] = useState(
    IndividualDocuments?.additional_reference_number,
  );
  const [showExpiryDate, setShowExpiryDate] = useState(false);

  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      setCountryName(countryName);
    }
  };
  const Handledocumenttype = (document_type: any) => {
    const EmpDocTypes = _.filter(allEmpDocTypes, function (c: any) {
      return c.type === document_type;
    });
    if (EmpDocTypes.length) {
      const empdocty = EmpDocTypes[0];
      setEmpDocTypeId(empdocty.id);
      setdocument_type(document_type);

      if (empdocty.reference_number_required === 1) {
        setShowReferenceNo(true);
      } else {
        setShowReferenceNo(false);
      }

      if (empdocty.additional_reference_number_required === 1) {
        setShowAddReferenceNo(true);
      } else {
        setShowAddReferenceNo(false);
      }

      if (empdocty.expiry_date_required === 1) {
        setShowExpiryDate(false);
      } else {
        setShowExpiryDate(true);
        setExpiredDate('');
      }
    }
  };
  const attachmentUpload = (e: any) => {
    setNewAttachement(true);
    const file: any = e.target.files[0];
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setProofAttachment(image_as_files);
      setProofAttachmentPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setProofAttachment(file);
    }
  };
  const handleSubmit = () => {
    callBackData({
      docId: IndividualDocuments?.id,
      documentTypeId: EmpDocTypeId,
      countryName: countryName,
      issueDate: issueDate,
      expiredDate: expiredDate,
      identifierNo: identifierNo,
      remarks: remarks,
      file: proofAttachment,
      removed: removeImage,
      newattachement: newattachement,
      showReferenceNo: showReferenceNo,
      showAddReferenceNo: showAddReferenceNo,
      referenceNo: referenceNo,
      addReferenceNo: addReferenceNo,
      showExpiryDate: showExpiryDate,
    });
  };

  useEffect(() => {
    const EmpDocTypes = _.filter(allEmpDocTypes, function (c: any) {
      return c.id === EmpDocTypeId;
    });

    if (EmpDocTypes.length) {
      const empdocty = EmpDocTypes[0];

      if (empdocty.reference_number_required === 1) {
        setShowReferenceNo(true);
      } else {
        setShowReferenceNo(false);
      }

      if (empdocty.additional_reference_number_required === 1) {
        setShowAddReferenceNo(true);
      } else {
        setShowAddReferenceNo(false);
      }

      if (empdocty.expiry_date_required === 1) {
        setShowExpiryDate(false);
      } else {
        setShowExpiryDate(true);
        setExpiredDate('');
      }
    }
  }, [EmpDocTypeId, allEmpDocTypes]);

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="570px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Documents') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '35px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Document Type')}
              value={document_type}
              options={_.map(allEmpDocTypes, (EmpDoctype: any) => {
                return EmpDoctype.type;
              })}
              onChange={(event: any, newValue: any) => {
                Handledocumenttype(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Issue Country')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={countryName}
              onChange={(event: any, newValue: any) => {
                handleSetCounty(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Issue Date')}
              value={issueDate}
              width="100%"
              defaultValue={IndividualDocuments?.issue_date}
              onChange={(newValue: any) => {
                setissueDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Expire Date')}
              value={expiredDate}
              width="100%"
              defaultValue={IndividualDocuments.validity_date}
              disabled={showExpiryDate}
              onChange={(newValue: any) => {
                setExpiredDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Identifier Number')}
              placeholder={trans('Identifier Number')}
              value={identifierNo}
              onChange={(e: any) => setIdentifierNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Remarks')}
              placeholder={trans('Write Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>
          {showReferenceNo ? (
            <Grid item xs={6} style={{ marginTop: '0.5em' }}>
              <CustomTextField
                type=""
                label={trans('Reference No.')}
                placeholder={trans('Reference No.')}
                value={referenceNo}
                onChange={(e: any) => setReferenceNo(e.target.value)}
              />
            </Grid>
          ) : (
            <></>
          )}
          {showAddReferenceNo ? (
            <Grid item xs={6} style={{ marginTop: '0.5em' }}>
              <CustomTextField
                type=""
                label={trans('Additional Reference No.')}
                placeholder={trans('Additional Reference No.')}
                value={addReferenceNo}
                onChange={(e: any) => setAddReferenceNo(e.target.value)}
              />
            </Grid>
          ) : (
            <></>
          )}
          <Grid item xs={12} style={{ marginTop: '0.5em', flexGrow: 1 }}>
            <Grid item xs={6}>
              <DropAndSelect
                upload={attachmentUpload}
                src={proofAttachmentPath}
                isAttachmentSigned={true}
                isPDF={isPDF}
                pdfName={pdfName}
                onDelete={() => {
                  setPDFName('');
                  setIsPDF(false);
                  setProofAttachmentPath('');
                  setRemoveImage('true');
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default EditDocsModalPresenter;
